import { EmberChangeset } from "ember-changeset";

type EmberChangesetConstructorParameters = ConstructorParameters<
  typeof EmberChangeset
>;

/** This EmberChangeset subclass is generic and properly types its data */
export default class TypedEmberChangeset<
  T extends object
> extends EmberChangeset {
  override get data(): T {
    return super.data as T;
  }

  constructor(
    obj: T,
    validateFn?: EmberChangesetConstructorParameters[1],
    validationMap?: EmberChangesetConstructorParameters[2]
  ) {
    super(obj, validateFn, validationMap);
  }
}
